import styled from "styled-components";

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.alignItems || "center"};
  gap: ${(props) => props.gap || "10px"};
`;

export default Column;
